import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

type subHeaderTypes = {
  heading: string;
  subheading?: string;
  path: string;
};

const defaultProps: subHeaderTypes = {
  heading: "",
  subheading: "",
  path: ""
};

export default function SubHeader({ heading, subheading, path }: subHeaderTypes) {
  const { t } = useTranslation();

  return (
    <div className="bg-black text-white w-screen drop-shadow-md">
      <div className="py-6 text-center">
        <h1 className="text-3xl mb-0.5">{heading}</h1>
        <nav role="navigation" aria-label="breadcrumbs">
          <NavLink to={"/"} className="transition text-lg hover:text-ct-yellow">
            {t("local.redeem.subtitle.main")}
          </NavLink>
          {subheading && (
            <span>
              <span className="mx-3">/</span>
              <NavLink to={path} className="transition text-lg hover:text-ct-yellow">
                {subheading}
              </NavLink>
            </span>
          )}
          <span className="mx-3">/</span>
          <span className="text-lg">{heading}</span>
        </nav>
      </div>
    </div>
  );
}
SubHeader.defaultProps = defaultProps;
